<template>
  <!--
          作者：caoshixian
          时间：2020-10-21
          描述：分享有礼页面
      -->
  <div class="share-list">
    <el-tabs v-model="sheareList" @tab-click="handleClick">
      <el-tab-pane label="分享记录" name="sharepolite"></el-tab-pane>
      <el-tab-pane label="分享设置" name="share-setting"></el-tab-pane>
      <el-tab-pane label="基本设置" name="setting"></el-tab-pane>
    </el-tabs>

    <sharepolite v-if="name === 'sharepolite'"></sharepolite>
    <setting v-else-if="name === 'setting'"></setting>
    <shareset v-else></shareset>
  </div>
</template>

<script>
import IndexApi from "@/api/index.js";
import sharepolite from "@/components/sharepolite/sharepolite.vue";
import setting from "@/components/sharepolite/setting.vue";
import shareset from "@/components/sharepolite/shareset.vue";

export default {
  data() {
    return {
      name: "sharepolite",
      sheareList: "sharepolite",
    };
  },
  components: {
    sharepolite: sharepolite,
    setting: setting,
    shareset: shareset,
  },
  created() {},
  methods: {
    handleClick(tab) {
      let tarbarname = tab.name;
      this.name = tarbarname;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/plus/sharepolite/index.vue